/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from 'react';
import { withStyles, createTheme, ThemeProvider } from '@material-ui/core/styles'

import { Paper, Typography, Divider, TextField, IconButton, Collapse, Button } from '@material-ui/core'
import { ExpandLess, ExpandMore, Delete } from '@material-ui/icons'

import { v4 as uuidv4 } from 'uuid';

const blue_theme = createTheme({
    palette: {
        primary: {
          main: '#2296f3',
        },
        secondary: {
            main: '#dc014e',
        }
      },
})

const styles = theme => ({

})


class DataSource extends Component {
    state = {
        open : false
    }

    updateSource = (key_name, value) => {
        let config = {...this.props.config}
        config[key_name] = value
        console.log('DQM Updating Config : ', config)
        this.props.update_source(config)
    }

    updateDimensionValue = (dimension_name, value) => {
        let dimension_values = [...this.props.config.dimension_values]
        let dimension_index = dimension_values.findIndex(dimension => dimension.name === dimension_name)

        if (dimension_index !== -1) {
            dimension_values[dimension_index].value = value
        }
        this.updateSource('dimension_values', dimension_values)
    }

    renderSourceContent = () => {
        return (
            <div>
                <Collapse in = {this.state.open}>
                    <Divider style = {{marginTop : '10px', marginBottom : '5px'}}/>
                    {this.renderDimensions()}
                    <Divider style = {{marginTop : '10px', marginBottom : '5px'}}/>
                    {this.renderFields()}
                </Collapse>
            </div>
        )
    }

    getDimensionDisplayName = (dimension_name) => {
        let dimension = this.props.dimensions.find(dim => dim.name === dimension_name)
        if (dimension) {
            return dimension.display
        }
    }

    getDimensionVisibility = (dimension_name) => {
        let dimension = this.props.dimensions.find(dim => dim.name === dimension_name)
        if (dimension) {
            return dimension.visible
        }
    }

    renderDimensions = () => {
        return (
            <div style = {{marginTop : '10px'}}>
                <Typography style = {{marginBottom : '10px'}} variant = 'subtitle2'>All Fields Dimension Values</Typography>
                <div style = {{display : 'flex', flexDirection : 'row'}}>
                    {this.props.config.dimension_values.map(dimension => {
                        return (
                            <Paper variant = 'outlined' style = {{padding : '10px', display : 'flex', flexDirection : 'row', alignItems : 'center', margin : '5px'}}>
                                <TextField 
                                    size='small' 
                                    style = {{flexGrow : 1, width : '40%'}} 
                                    id={dimension.name} 
                                    value = {dimension.value}
                                    label={this.getDimensionDisplayName(dimension.name) + ' Score'} 
                                    onChange = {(event) => this.updateDimensionValue(dimension.name, event.target.value)}
                                    disabled = {!this.getDimensionVisibility(dimension.name)}
                                />
                            </Paper>
                        )
                    })}
                </div>
            </div>
        )
    }

    renderFields = () => {
        return (
            <div style = {{marginTop : '10px'}}>
                <Typography style = {{marginBottom : '10px'}} variant = 'subtitle2'>Fields</Typography>
                {this.props.config.fields.map(field => {
                    return (
                        <Paper 
                            key = {field.id}
                            variant = 'outlined' 
                            style = {{padding : '10px', display : 'flex', flexDirection : 'row', alignItems : 'center', margin : '5px'}}
                        >
                            <TextField
                                key = {field.id + '_name'}
                                size='small' 
                                style = {{flexGrow : 1, marginRight : '10px'}} 
                                label='Field Name'
                                value = {field.name}
                                onChange = {(event) => this.updateFieldValue(field.id, 'name', event.target.value)}
                            />
                            {field.dimension_values.map(dimension => {
                                console.log('DQM Rendering Field Dimension: ', dimension)
                                return (
                                    <TextField 
                                        key = {field.id + '_' + dimension.name}
                                        size='small' 
                                        style = {{flexGrow : 1, marginRight : '10px'}} 
                                        value = {dimension.value}
                                        label={this.getDimensionDisplayName(dimension.name)  + ' Score'} 
                                        onChange = {(event) => this.updateFieldValue(field.id, dimension.name, event.target.value)}
                                        disabled = {!this.getDimensionVisibility(dimension.name)}
                                    />
                                )
                            })}
                            <IconButton
                                size = 'small'
                                color = 'secondary'
                                onClick = {() => this.deleteField(field.id)}
                            >
                                <Delete fontSize='small'/>
                            </IconButton>
                        </Paper>
                    )
                })}
                <Button
                    size = 'small'
                    color = 'primary'
                    onClick = {this.addField}
                >Add Field</Button>
            </div>
        )
    }

    updateFieldValue = (field_id, key_name, value) => {
        console.log('DQM Updating Field : ', field_id)
        let fields = [...this.props.config.fields]
        let field_index = fields.findIndex(field => field.id === field_id)
        if (field_index !== -1) {
            if (key_name === 'name') {
                fields[field_index].name = value
            } else {
                let dimension_index = fields[field_index].dimension_values.findIndex(dmn => dmn.name === key_name)

                if (dimension_index !== -1) {
                    fields[field_index].dimension_values[dimension_index].value = value
                }
            }

            this.updateSource('fields', fields)
        }
    }

    deleteField = (field_id) => {
        let fields = [...this.props.config.fields]
        let field_index = fields.findIndex(field => field.id === field_id)
        if (field_index !== -1) {
            fields.splice(field_index, 1)
            this.updateSource('fields', fields)
        }
    }

    addField = () => {
        let field_temp = {
            name : '',
            dimension_values : [
                {
                    name : 'uniqueness',
                    value : ''
                },
                {
                    name : 'completeness',
                    value : ''
                },
                {
                    name : 'accuracy',
                    value : ''
                },
                {
                    name : 'validity', 
                    value : ''
                },
                {
                    name : 'consistency',
                    value : ''
                },
                {
                    name : 'compliance',
                    value : ''
                }
            ]
        }
        let fields = [...this.props.config.fields]
        let new_field = {...field_temp}
        console.log('DQM Adding new field : ', new_field)
        new_field.id = uuidv4()
        console.log('DQM Data Source Fields New : ', new_field)
        fields.push(new_field)
        console.log('DQM Data Source Fields : ', fields)
        this.updateSource('fields', fields)
    }

    render() { 
        return (
            <ThemeProvider theme = {blue_theme}>
                <Paper 
                    style = {{padding : '10px'}} 
                    square
                    variant = 'outlined'
                >
                    <div style = {{display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                        <IconButton
                            style = {{marginRight : '5px'}}
                            onClick = {() => this.setState({...this.state, open : !this.state.open})}
                        >
                            {this.state.open ? <ExpandLess/> : <ExpandMore/>}
                        </IconButton>
                        <TextField 
                            style = {{flexGrow : 1, marginRight : '10px'}}
                            id="nme" 
                            label="Application Name" 
                            variant="filled" 
                            size='small'
                            value = {this.props.config.name}
                            onChange={(event) => this.updateSource('name', event.target.value)}
                        />
                        <TextField 
                            style = {{flexGrow : 1}}
                            id="db_nme" 
                            label="Database Name" 
                            variant="filled" 
                            size='small'
                            value = {this.props.config.database_name}
                            onChange={(event) => this.updateSource('database_name', event.target.value)}
                        />
                        <IconButton
                            color = 'secondary'
                            onClick = {() => this.props.delete_source(this.props.config)}
                        >
                            <Delete fontSize='small'/>
                        </IconButton>
                    </div>
                    {this.renderSourceContent()}
                </Paper>
            </ThemeProvider>
        );
    }
}
 
export default withStyles(styles)(DataSource);